import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { HttpParams } from '@angular/common/http'

import { ResourceService } from '../../../common/services/resource.service'
import { Paginator } from '../../../common/interfaces/paginator.interface'
import { BreadcrumbService } from '../../../common/services/breadcrumb.service'
import { FlashMessagesService } from 'angular2-flash-messages'
import { appConstants } from '../../../app.constants'

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.scss'],
  providers: [ResourceService]
})
export class CompanyListComponent implements OnInit {
  paginator: Paginator
  loading: boolean

  constructor(
    private resourceService: ResourceService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private flashMessagesService: FlashMessagesService,
    breadcrumbService: BreadcrumbService
  ) {
    breadcrumbService.breadcrumbLinks.next([
      {
        path: '/companies',
        label: "Bureaux d'études"
      }
    ])
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((queryParams: any) => {
      // Create request params and set actual params (in case of reload)
      let params = new HttpParams()
      params = params.set('page', queryParams.page ? queryParams.page : 1)
      params = params.set('includeNotActive', 'true')

      if (queryParams.toXLS) {
        params = params.set('toXLS', 'true')
        this.resourceService
          .download('companies', params, 'companies.xlsx')
          .subscribe(() => {
            const exportParams: any = {}
            exportParams.toXLS = null
            this.router.navigate(['/companies'], {
              queryParams: exportParams,
              queryParamsHandling: 'merge'
            })
          })
      } else {
        this.loading = true
        this.resourceService.list('companies', params).subscribe(
          (companyRes: Paginator) => {
            this.loading = false
            this.paginator = companyRes
          },
          error => {
            this.loading = false
            this.flashMessagesService.show(
              'Une erreur a eu lieu : Impossible de récupérer le(s) élémént(s) désiré(s).',
              {
                cssClass: 'notification is-danger',
                timeout: appConstants.FLASH_MESSAGE_TIMEOUT
              }
            )
          }
        )
      }
    })
  }
}
